'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.bindAll = undefined;

var _getOwnPropertyNames = require('babel-runtime/core-js/object/get-own-property-names');

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bindAll = exports.bindAll = function bindAll(context) {
	var prototypes = (0, _getOwnPropertyNames2.default)(context.__proto__);
	prototypes.forEach(function (prototype) {
		if (typeof context[prototype] == 'function' && prototype.indexOf('_') == 0) {
			context[prototype] = context[prototype].bind(context);
		}
	});
	return context;
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/helpers/helper.js
 ** module id = 184
 ** module chunks = 0
 **/